import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem 4rem;
  max-width: 1600px;
  text-align: center;
`;
